import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/stores/[storeId]/components/sotrby.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/stores/[storeId]/components/StoreAvailability.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/stores/[storeId]/product/components/InfintyProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/stores/components/filter.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/stores/components/FreeDeliveryBage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/stores/components/IsFavorite.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/SearchQuery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Drawer","DrawerTrigger","DrawerTitle","DrawerContent"] */ "/app/components/ui/drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.1.0_next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0_typescript@5.8.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.1.0_next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0_typescript@5.8.3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/Fast.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/location.svg");
;
import(/* webpackMode: "eager" */ "/app/public/logo.svg");
